"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.snakeToCamelCase = exports.objectKeysToSnakeCase = exports.camelToSnakeCase = void 0;
const camelToSnakeCase = (text) => {
    return text.replace(/[A-Z]/g, (letter) => `_${letter.toLocaleLowerCase()}`);
};
exports.camelToSnakeCase = camelToSnakeCase;
const objectKeysToSnakeCase = (obj) => {
    return Object.keys(obj).reduce((result, key) => {
        const snakeKey = exports.camelToSnakeCase(key);
        result[snakeKey] = obj[key];
        return result;
    }, {});
};
exports.objectKeysToSnakeCase = objectKeysToSnakeCase;
const snakeToCamelCase = (text) => {
    return text.replace(/_[a-z,A-Z]/g, (group) => group.replace('_', '').toUpperCase());
};
exports.snakeToCamelCase = snakeToCamelCase;
